import React, { useEffect, useState } from "react";
import style from "./VendorCount.module.css";
import CommonButton from "../CommonButton";

const activeVendorStyle = {
  border: "1px #3E9B67 solid",
  boxShadow: " 0px 4px 4px rgba(0, 0, 0, 0.25)",
  backgroundColor: "#EBFFF4",
};

const VendorCount = ({
  showToast = () => {},
  count = 0,
  onApply = () => {},
}) => {
  const [vendorCount, setVendorCount] = useState([]);

  const onClickHandler = (e) => {
    let clickedId = e?.target?.id;
    setVendorCount((prevData) =>
      prevData.map((item, idx) =>
        idx == clickedId ? { ...item, isActive: !item?.isActive } : item
      )
    );
  };

  const selectAllHandler = () => {
    setVendorCount((prevData) => {
      let isAllSelected = prevData?.find((obj) => !obj?.isActive);
      return prevData.map((item) => ({
        ...item,
        isActive: isAllSelected ? true : false,
      }));
    });
  };

  const applyHandler = () => {
    let selectedVendors = vendorCount?.filter((obj) => obj?.isActive);
    if (!selectedVendors?.length)
      return showToast("Please select vendors", "warning", true);

    onApply(selectedVendors?.map((obj) => obj?.id));
    setVendorCount((prevData) => {
      return prevData.map((item) => ({
        ...item,
        isActive: false,
      }));
    });
  };

  useEffect(() => {
    const vendors = [];
    for (let i = 1; i <= count; i++) {
      vendors.push({ id: i, vendorCount: `Vendor ${i}` });
    }
    setVendorCount(vendors);
  }, [count]);

  return (
    <div>
      <h1 className={style["header"]}>{`Assign blocks to Vendor: ${count}`}</h1>
      <div className={style["vendor_count_container"]}>
        {vendorCount?.map((item, idx) => (
          <h1
            key={`vendor_count_${idx}`}
            id={idx}
            className={style["vendor_count_label"]}
            style={item?.isActive ? { ...activeVendorStyle } : {}}
            onClick={onClickHandler}
          >
            {item?.vendorCount}
          </h1>
        ))}
      </div>
      <div className={style["btn_container"]}>
        <button className={style["btn_one"]} onClick={selectAllHandler}>
          {vendorCount?.find((obj) => !obj?.isActive)
            ? "Select All"
            : "Deselect All"}
        </button>
        <button className={style["btn_two"]} onClick={applyHandler}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default VendorCount;
